export default "__VITE_ASSET__BLAnZnwI__"